var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleExclamationOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 2.66732C10.9408 2.66732 13.3335 5.05998 13.3335 8.00065C13.3335 10.9413 10.9408 13.334 8.00016 13.334C5.0595 13.334 2.66683 10.9413 2.66683 8.00065C2.66683 5.05998 5.0595 2.66732 8.00016 2.66732ZM8.00016 1.33398C4.31816 1.33398 1.3335 4.31865 1.3335 8.00065C1.3335 11.6827 4.31816 14.6673 8.00016 14.6673C11.6822 14.6673 14.6668 11.6827 14.6668 8.00065C14.6668 4.31865 11.6822 1.33398 8.00016 1.33398ZM8.66483 7.33665H7.3255V11.3366H8.66483V7.33665ZM7.3255 4.66998H8.66483V6.00932H7.3255V4.66932V4.66998Z",
    fill: "#149CE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleExclamationOutlined);
export default __webpack_public_path__ + "static/media/circle-exclamation-outlined.39e921c31b6123988cb33e0ccc43a215.svg";
export { ForwardRef as ReactComponent };